import { Box } from "@chakra-ui/react";
import { FC, useMemo } from "react";

import { PageLayout } from "~/src/components/features/global/PageLayout";

export type Props = {
  siteSlug: string;
};

export const FunnelImportPage: FC<React.PropsWithChildren<Props>> = ({
  children,
  siteSlug,
}) => {
  const breadcrumbs = useMemo(
    () => [
      { label: "設定", path: `/sites/${siteSlug}/settings` },
      {
        label: "ファネルインポート",
        path: `/sites/${siteSlug}/funnels/import`,
      },
    ],
    [siteSlug]
  );

  return (
    <PageLayout title="ファネルインポート" breadcrumbs={breadcrumbs}>
      <Box mt="32px">{children}</Box>
    </PageLayout>
  );
};
